import React from 'react';
import { css } from '@emotion/react';
import { useSelector } from 'react-redux';

import t from 'react-translate';
import { AngularContext } from 'react-app';
import NvTooltip from 'shared/components/nv-tooltip';
import { Course } from 'redux/schemas/models/course';
import { getCurrentUserEnrollments } from 'redux/selectors/users';
import {
  ReactComponent as CohortBadgeIcon,
} from 'styles/icons/cohort-badge.svg';
import {
  ReactComponent as PrimaryBadgeIcon,
} from 'styles/icons/primary-badge.svg';

type Props = {
  course: Course,
  className?: string,
};

const BADGE_SIZE = 22;

const styles = css`
  top: -3px;
  position: absolute;
  left: -${BADGE_SIZE / 2}px;
`;

const Badge = (props: Props) => {
  const { course, className } = props;
  const { isPrimary, isCohort, userCourse } = course;

  const { injectServices } = React.useContext(AngularContext);
  const Icon = isPrimary ? PrimaryBadgeIcon : CohortBadgeIcon;
  const [CurrentPermissionsManager] = injectServices(['CurrentPermissionsManager']);
  const hasCourseAdminPermissions = CurrentPermissionsManager.hasOrgAdminPermissions() || CurrentPermissionsManager.hasCourseManagerPermissions();
  const userEnrollments = useSelector(getCurrentUserEnrollments);
  const courseEnrollment = userEnrollments?.find(e => e?.courseCatalogId === course.catalogId);
  const isCourseAdminEnrollment = courseEnrollment ? courseEnrollment.isCourseAdmin : true;

  if ((isPrimary || isCohort) && (hasCourseAdminPermissions || isCourseAdminEnrollment)) {
    return (
      <NvTooltip text={isPrimary ? t.COHORT_MANAGEMENT.PRIMARY() : t.COHORT_MANAGEMENT.COHORT()}>
        <Icon
          css={styles}
          width={BADGE_SIZE}
          height={BADGE_SIZE}
          className={className}
        />
      </NvTooltip>
    );
  }

  return null;
};

export default Badge;
